import React, {useState, useEffect, Fragment} from "react";
import styled from "styled-components";
import {getCommaNumber} from "utils/format";
import {getOrderStateName, getOrderTypeName, getServiceTypeColor, getServiceTypeName} from "utils/define";
import PaymentForm from "./PaymentForm";



/**
 * [주문 이용권 정보]
 */

export const PassInfo = ({data}) => {
	// b.pay 일반 구매(PASS)는 재구매 부모 주문이 있어도 이전 이용권 정가를 빼지 않는다(양도·업그레이드 등만 뺀다)
	const isBpayPlainPass = (data.webAppDiv == "A" && data.orderType == "PASS");
	const beforePrice = (isBpayPlainPass) ? 0 : (data.beforePrice || 0);
	const totalDiscountAmount = Math.max((data.price || 0) - beforePrice - (data.salePrice || 0), 0);
	const getDiscountAmount = () => {
		return getCommaNumber(totalDiscountAmount) + "원";
	};
	// 내역(쿠폰·핫딜·포인트 또는 일반 할인·포인트)에 없는 할인은 기타 할인으로 보인다
	const getEtcDiscount = () => {
		const shownAmount = (data.webAppDiv == "A") ?
			(data.bpayCouponDiscountAmount || 0) + (data.bpayHotDealDiscountAmount || 0) + (data.bpayPointDiscountAmount || 0) :
			(data.discountAmount || 0) + (data.usePoint || 0);
		const etcAmount = totalDiscountAmount - shownAmount;
		return (etcAmount > 0) ? (<li><div>기타 할인</div><div>{getCommaNumber(etcAmount)}원</div></li>) : null;
	};
	const orderStateName = data.orderStateName || getOrderStateName(data.orderState)
	// const orderTypeName = getOrderTypeName(data.orderType);

	const getDiscountInfo = () => {
		return (data.webAppDiv == "A") ? (
			<ul>
				<li><div>쿠폰 할인</div><div>{getCommaNumber(data.bpayCouponDiscountAmount)}원</div></li>
				<li><div>핫딜 할인</div><div>{getCommaNumber(data.bpayHotDealDiscountAmount)}원</div></li>
				<li><div>포인트 사용</div><div>{getCommaNumber(data.bpayPointDiscountAmount)}원</div></li>
				{getEtcDiscount()}
			</ul>
		) : (
			<ul>
				<li><div>일반 할인</div><div>{getCommaNumber(data.discountAmount)}원</div></li>
				<li><div>포인트 사용</div><div>{getCommaNumber(data.usePoint)}원</div></li>
				{getEtcDiscount()}
			</ul>
		);
	};

	const getPackageInfo = () => {
		if(!data.passInfoResponses) return null;
		const li = (data.passInfoResponses || []).map((item, index) => {
			const serviceTypeColor = getServiceTypeColor(item.serviceType);
			const serviceTypeName = getServiceTypeName(item.serviceType);
			return (
				<li key={index}>
					<div className={serviceTypeColor}>{serviceTypeName}</div>
					<div>{item.passName}</div>
				</li>
			);
		});
		return (
			<li>
				<div>패키지 구성</div>
				<div></div>
				<ul className="color">{li}</ul>
			</li>
		);
	};

	return (
		<Wrapper>
			<h4>주문 정보</h4>
			<ul>
				{getPackageInfo()}
				<li><div>주문상태</div><div>{orderStateName}</div></li>
				<li><div>정가</div><div>{getCommaNumber(data.price)}원</div></li>
				<li><div>이전 이용권 정가</div><div>{getCommaNumber(beforePrice)}원</div></li>
				<li>
					<div>총 할인금액</div><div>{getDiscountAmount()}</div>
					{getDiscountInfo()}
				</li>
				<li><div>판매가</div><div>{getCommaNumber(data.salePrice)}원</div></li>
				<li><div>결제금액</div><div>{getCommaNumber(data.orderAmount)}원</div></li>
				<li><div>미수금</div><div><span className="red">{getCommaNumber(data.receivables)}원</span></div></li>
			</ul>
		</Wrapper>
	);
};

const Wrapper = styled(PaymentForm)`
	margin-bottom: 22px;
	padding: 22px;
	background-color: #f9fbff;
	border-radius: 12px;
	border: 1px solid #f0f3f9;
	.color {
		.appointment		{color:var(--appointment) !important}
		.class				{color:var(--class) !important}
		.place				{color:var(--place) !important}
		.option				{color:var(--option) !important}
	}
`;

export default PassInfo;